import styled from 'styled-components'
import { ButtonMui } from 'src/components/ButtonMui'

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  margin: 1.3rem 0 .3rem 0;
`

export const ContainerBottom = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
`

export const CustomButton = styled(ButtonMui)`
  width: 14rem;    
  height: 2.5rem !important;
`
